"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Tab_1 = __importDefault(require("../Tab"));
var react_1 = __importStar(require("react"));
var Tabs_1 = __importDefault(require("../Tabs"));
var react_i18next_1 = require("react-i18next");
var styles_1 = require("./styles");
var useLayoutLinks_1 = require("./hooks/useLayoutLinks");
var TabRow = function (_a) {
    var handleNavigation = _a.handleNavigation, vibePointLoading = _a.vibePointLoading, links = _a.links, newTabProps = _a.newTabProps, routerPath = _a.routerPath;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = __read((0, react_1.useState)(false), 2), activeLink = _b[0], setActiveLink = _b[1];
    (0, react_1.useEffect)(function () {
        var pathname = routerPath || window.location.pathname;
        var isActiveTab = function (link) {
            return link.url.length > 1
                ? pathname.startsWith(link.url)
                : pathname === link.url;
        };
        var primaryLink = links.primaryLinks.find(isActiveTab);
        setActiveLink((primaryLink === null || primaryLink === void 0 ? void 0 : primaryLink.url) || false);
    }, [links.primaryLinks, routerPath]);
    var LoadingTabs = function () { return (react_1.default.createElement(Tabs_1.default, { value: 0, "aria-role": "tablist" }, Array(3)
        .fill('')
        .map(function (_, i) { return (react_1.default.createElement(Tab_1.default, { key: i, label: react_1.default.createElement(styles_1.HeaderTabSkeleton, null), "aria-label": t('prism-header:loading', 'Loading') })); }))); };
    if (vibePointLoading) {
        return react_1.default.createElement(LoadingTabs, null);
    }
    return (react_1.default.createElement(Tabs_1.default, { value: activeLink, textColor: "secondary", TabIndicatorProps: { sx: { background: 'white' } }, "aria-role": "tablist" }, links.primaryLinks.map(function (_a) {
        var id = _a.id, translationString = _a.translationString, url = _a.url;
        return (react_1.default.createElement(Tab_1.default, __assign({ key: id, value: url, className: "fs-unmask", sx: styles_1.tabFocusOverride, disableFocusRipple: true, href: url, "data-testid": "".concat(translationString, "-link"), onClick: handleNavigation(url), label: t("prism-header:".concat(translationString)) }, (id === useLayoutLinks_1.PrimaryLinks.Wellbeing && newTabProps))));
    })));
};
exports.default = TabRow;
//# sourceMappingURL=TabRow.js.map